// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1hIyV","notes":"Notes_notes__231BP"};